import React from 'react';

const ClientHubPayment = (props: {
  isMobile: boolean;
  activeSection: string;
  track: Function;
  sitelinkId: string;
  storePhone: string;
}) => {
  const { isMobile, activeSection, track, sitelinkId, storePhone } = props;
  const id = 'payment';

  const showSection = () => {
    if (isMobile) return activeSection === id;
    return true;
  };

  return (
    <div style={{ display: showSection() ? 'block' : 'none' }}>
      <h3
        id="payment"
        style={{ textTransform: 'none', backgroundColor: 'aliceblue' }}
      >
        Payments
      </h3>
      <div>
        Accounts are billed on a 4-week cycle from your move-in date. You only
        need to pay the current cycle. For more information, please see the FAQs
        section. <br />
        <br />
        <div>
          <b>Pay online</b>
          <br />
          Visit our secure client portal:{' '}
          <a
            style={{ textDecoration: 'none' }}
            target="_blank"
            rel="noreferrer"
            onClick={() => track('Open MyAccount')}
            href={`https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=${sitelinkId}==&1=1`}
          >
            My Account
          </a>{' '}
          <br />
          Once logged in: <br />
          <span style={{ paddingLeft: '10px', display: 'block' }}>
            1. Select your unit
          </span>
          <span style={{ paddingLeft: '10px', display: 'block' }}>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            2. Go to "Make a Payment" to pay by credit card or direct debit
          </span>
        </div>
        <hr />
        <div>
          <b>Pay by phone</b>
          <br />
          Call us at{' '}
          <a
            style={{ textDecoration: 'none' }}
            onClick={() => track('Call store')}
            href={`tel:${storePhone}`}
          >
            {storePhone}
          </a>{' '}
          and we’ll help process your payment. <br />
        </div>
      </div>
      <hr />
      <br />
    </div>
  );
};

export default ClientHubPayment;
